// ─── Seed Data ────────────────────────────────────────────────────────────────
function svg64(emoji, bg, s = 200) {
  const raw = `<svg xmlns="http://www.w3.org/2000/svg" width="${s}" height="${s}">
    <rect width="${s}" height="${s}" rx="${s * 0.1}" fill="${bg}"/>
    <text x="${s / 2}" y="${s * 0.65}" font-size="${s * 0.48}" text-anchor="middle" font-family="serif">${emoji}</text>
  </svg>`
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(raw)}`
}

const RAW_IMGS = [
  { e:'🐘', b:'#E8E4DF', c:'animals',    en:'Elephant',  ml:'ആന',        hi:'हाथी',      ta:'யானை',          te:'ఏనుగు'         },
  { e:'🦁', b:'#F5E8CC', c:'animals',    en:'Lion',      ml:'സിംഹം',     hi:'शेर',       ta:'சிங்கம்',       te:'సింహం'         },
  { e:'🐬', b:'#CCE5F5', c:'animals',    en:'Dolphin',   ml:'ഡോൾഫിൻ',   hi:'डॉल्फिन',   ta:'டால்பின்',      te:'డాల్ఫిన్'      },
  { e:'🦋', b:'#F5CCE8', c:'animals',    en:'Butterfly', ml:'ശലഭം',      hi:'तितली',     ta:'பட்டாம்பூச்சி', te:'సీతాకోకచిలుక' },
  { e:'🍎', b:'#FFD6D6', c:'fruits',     en:'Apple',     ml:'ആപ്പിൾ',   hi:'सेब',       ta:'ஆப்பிள்',       te:'యాపిల్'        },
  { e:'🍌', b:'#FFFACC', c:'fruits',     en:'Banana',    ml:'വാഴപ്പഴം',  hi:'केला',      ta:'வாழைப்பழம்',    te:'అరటిపండు'      },
  { e:'🥕', b:'#FFE0C0', c:'vegetables', en:'Carrot',    ml:'കാരറ്റ്',   hi:'गाजर',      ta:'கேரட்',         te:'క్యారెట్'      },
  { e:'🚌', b:'#FFE5C0', c:'transport',  en:'Bus',       ml:'ബസ്',       hi:'बस',        ta:'பேருந்து',       te:'బస్సు'         },
  { e:'✈️', b:'#D6E8FF', c:'transport',  en:'Airplane',  ml:'വിമാനം',    hi:'हवाई जहाज़', ta:'விமானம்',       te:'విమానం'        },
  { e:'🌳', b:'#D6F5D6', c:'nature',     en:'Tree',      ml:'മരം',        hi:'पेड़',       ta:'மரம்',           te:'చెట్టు'        },
  { e:'☀️', b:'#FFF5C0', c:'nature',     en:'Sun',       ml:'സൂര്യൻ',    hi:'सूरज',      ta:'சூரியன்',       te:'సూర్యుడు'      },
  { e:'🏠', b:'#E0E8FF', c:'household',  en:'House',     ml:'വീട്',      hi:'घर',        ta:'வீடு',           te:'ఇల్లు'         },
  { e:'😊', b:'#FFF3CC', c:'emotions',   en:'Happy',     ml:'സന്തോഷം',   hi:'खुश',       ta:'மகிழ்ச்சி',     te:'సంతోషం'        },
  { e:'😢', b:'#D6E8FF', c:'emotions',   en:'Sad',       ml:'ദുഃഖം',     hi:'दुखी',      ta:'சோகம்',         te:'దుఃఖం'         },
  { e:'✋', b:'#FFE8D0', c:'body',       en:'Hand',      ml:'കൈ',         hi:'हाथ',       ta:'கை',             te:'చేయి'          },
  { e:'👁️', b:'#E8F0FF', c:'body',      en:'Eye',       ml:'കണ്ണ്',     hi:'आंख',       ta:'கண்',            te:'కన్ను'         },
]

export const SEED_IMAGES = RAW_IMGS.map((s, i) => ({
  id        : `seed-${i}`,
  url       : svg64(s.e, s.b, 200),
  thumbnail : svg64(s.e, s.b, 120),
  category  : s.c,
  labels    : { en: s.en, ml: s.ml, hi: s.hi, ta: s.ta, te: s.te },
  tags      : [s.c],
  modules   : [],
  addedAt   : new Date(Date.now() - (16 - i) * 86400000).toISOString(),
  source    : 'library',
  filename  : `${s.en.toLowerCase()}.svg`,
  size      : 'SVG',
}))

export const SEED_CHILDREN = [
  { id:'c1', name:'Arjun K.',  age:5, dob:'2019-03-12', initials:'AK', color:'#1A4A6E', disability:['Hearing Impairment'],       gender:'M' },
  { id:'c2', name:'Priya M.',  age:6, dob:'2018-08-24', initials:'PM', color:'#C0392B', disability:['Autism Spectrum Disorder'],  gender:'F' },
  { id:'c3', name:'Rohan S.',  age:4, dob:'2020-01-15', initials:'RS', color:'#1B6B45', disability:['Down Syndrome'],             gender:'M' },
  { id:'c4', name:'Meera R.',  age:7, dob:'2017-11-05', initials:'MR', color:'#6B2D8B', disability:['Cerebral Palsy'],            gender:'F' },
]

export const SEED_ACTIVITY = [
  { id:'ac1', module:'flashcard',  child:'Arjun K.', action:'Animal Flashcard PDF generated',    time: new Date(Date.now() - 2   * 60000).toISOString(), icon:'🃏' },
  { id:'ac2', module:'progress',   child:'Meera R.', action:'Progress assessment updated',        time: new Date(Date.now() - 18  * 60000).toISOString(), icon:'📊' },
  { id:'ac3', module:'worksheet',  child:'Priya M.', action:'Odd One Out worksheet printed',      time: new Date(Date.now() - 3600000).toISOString(),     icon:'📝' },
  { id:'ac4', module:'storybook',  child:'Rohan S.', action:"Story Book 'Ellie' created",         time: new Date(Date.now() - 2 * 3600000).toISOString(), icon:'📖' },
  { id:'ac5', module:'collection', child:'—',        action:'16 seed images loaded',              time: new Date(Date.now() - 2 * 86400000).toISOString(),icon:'🗂️' },
]

export const SEED_WORK_PLANS = [{
  id       : 'wp-seed',
  title    : 'Week Plan — Animals Theme',
  weekOf   : '2026-03-02',
  child    : 'all',
  theme    : 'animals',
  createdAt: new Date().toISOString(),
  days     : [],
}]

export const DEFAULT_SETTINGS = {
  language       : 'en',
  printSize      : 'a4-portrait',
  showLogos      : true,
  showFooter     : true,
  showPageNumbers: true,
}
